import React from "react";
import {
  Grid,
  TextField,
  Typography,
  Button,
  Autocomplete,
  IconButton,
  Box,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

const unitOptions = ["g", "kg", "ml", "l", "unit"];

const IngredientSection = ({ form, updateField, ingredients }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const sortedIngredients = [...ingredients].sort((a, b) =>
    a.name.localeCompare(b.name)
  );

  const handleIngredientChange = (index, key, value) => {
    const updated = [...form.ingredients];
    updated[index][key] = value;
    updateField("ingredients", updated);
  };

  const addIngredient = () => {
    updateField("ingredients", [
      ...(Array.isArray(form.ingredients) ? form.ingredients : []),
      { ingredientId: "", quantity: 0, unit: "g" },
    ]);
  };

  const removeIngredient = (index) => {
    const updated = [...form.ingredients];
    updated.splice(index, 1);
    updateField("ingredients", updated);
  };

  return (
    <Grid item xs={12}>
      <Typography variant="subtitle1" fontWeight={600} gutterBottom>
        Ingredients
      </Typography>

      {(form.ingredients || []).map((i, idx) => {
        const selected = ingredients.find(
          (ing) =>
            ing._id === i.ingredientId ||
            (typeof i.ingredientId === "object" &&
              ing._id === i.ingredientId._id)
        );

        return (
          <Grid
            container
            spacing={1}
            key={idx}
            alignItems="center"
            sx={{
              mb: 2,
              px: { xs: 1, md: 0 },
            }}>
            <Grid item xs={12} sm={6}>
              <Autocomplete
                options={sortedIngredients}
                getOptionLabel={(option) => option.name}
                value={selected || null}
                onChange={(e, newValue) =>
                  handleIngredientChange(
                    idx,
                    "ingredientId",
                    newValue?._id || ""
                  )
                }
                renderInput={(params) => (
                  <TextField {...params} label="Ingredient" fullWidth />
                )}
              />
            </Grid>

            <Grid item xs={6} sm={3}>
              <TextField
                type="number"
                label="Quantity"
                fullWidth
                value={i.quantity}
                onChange={(e) =>
                  handleIngredientChange(idx, "quantity", e.target.value)
                }
              />
            </Grid>

            <Grid item xs={4} sm={2}>
              <TextField
                select
                label="Unit"
                fullWidth
                value={i.unit}
                onChange={(e) =>
                  handleIngredientChange(idx, "unit", e.target.value)
                }
                SelectProps={{ native: true }}>
                {unitOptions.map((unit) => (
                  <option key={unit} value={unit}>
                    {unit}
                  </option>
                ))}
              </TextField>
            </Grid>

            <Grid item xs={2} sm={1}>
              <IconButton
                onClick={() => removeIngredient(idx)}
                color="error"
                sx={{
                  mt: { xs: 1.5, sm: 0 },
                  width: 60,
                  height: 60,
                }}>
                <DeleteOutlineIcon fontSize="medium" />
              </IconButton>
            </Grid>
          </Grid>
        );
      })}

      <Box mt={2}>
        <Button onClick={addIngredient} fullWidth={isMobile} variant="outlined">
          + Add Ingredient
        </Button>
      </Box>
    </Grid>
  );
};

export default IngredientSection;
